var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 885 885",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.941575,0.24021,-0.24021,0.941575,278.63,-44.5567)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "wine-fill",
    transform: "matrix(1,0,0,1,-275.798,-68.7212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.555,183.199C701.259,245.191 667.511,283.264 625.081,389.337C561.644,495.065 519.353,579.648 498.207,643.085C477.061,579.648 429.501,489.683 366.064,383.955C355.979,371.966 363.595,345.956 409.019,308.403C433.879,287.853 439.337,270.838 468.915,251.485C542.997,203.014 665.44,155.308 676.555,183.199Z",
    style: {
      fill: "var(--wine-base, #6B0F1A)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.555,183.199C701.259,245.191 667.511,283.264 625.081,389.337C561.644,495.065 519.353,579.648 498.207,643.085C477.061,579.648 429.501,489.683 366.064,383.955C355.979,371.966 363.595,345.956 409.019,308.403C433.879,287.853 439.337,270.838 468.915,251.485C542.997,203.014 665.44,155.308 676.555,183.199Z",
    style: {
      fill: "url(#_Shade1)"
    }
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-276.177,-93.2709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498.349,893.306C537.024,893.306 575.037,918.664 615.551,922.505C668.13,927.489 720.237,929.385 720.237,944.217C720.237,970.476 621.826,981.387 499.284,981.387C376.743,981.387 276.177,970.476 276.177,944.217C276.177,926.441 315.898,924.852 383.983,920.677C416.474,918.685 454.631,893.306 498.349,893.306Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-275.798,-68.7212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.458,384.218C390.927,211.432 632.461,193.247 676.555,183.199M688.519,72.151C681.928,120.574 679.014,154.873 676.555,183.199M676.555,183.199C670.782,249.682 667.511,283.264 625.081,389.337C561.644,495.065 519.353,579.648 498.207,643.085C477.061,579.648 434.883,495.065 371.446,389.337L307.895,230.744C307.895,125.015 434.77,72.151 688.519,72.151",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 36
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.8593,0,0,15.8593,-285.089,-28.2891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,38L32,52",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bubbles"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.8593,0,0,15.8593,-268.151,-37.283)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 10,
    r: 3,
    style: {
      fill: "none",
      stroke: "var(--bubbles-stroke, currentColor)",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.8593,0,0,15.8593,-285.089,-28.2891)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 18,
    r: 2,
    style: {
      fill: "none",
      stroke: "var(--bubbles-stroke, currentColor)",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.8593,0,0,15.8593,-255.52,-42.1185)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 22,
    r: 1.8,
    style: {
      fill: "none",
      stroke: "var(--bubbles-stroke, currentColor)",
      strokeWidth: 2
    }
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Shade1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-33.6604,292.91,-292.91,-33.6604,494.785,273.679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#000000",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotated);
export default __webpack_public_path__ + "static/media/rotated.fa2f5acf9dadb4aaf80c965dc06cb913.svg";
export { ForwardRef as ReactComponent };